export default "__VITE_ASSET__DHU2qqbU__"